import * as React from 'react';

// MUI
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useSegment } from 'common/hooks/segment';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { TERMINAL_SCREENSHOTS_PARAMS } from './params';

export type Mode = 'specific-date' | 'date-range' | 'terminal';

export const ModeSelector: React.FC = () => {
  const { track } = useSegment();
  const { searchParams, setSearchParams } = useCustomSearchParams(TERMINAL_SCREENSHOTS_PARAMS);
  const { mode } = searchParams;

  const onChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newMode = event.target.value as Mode;

      let eventTitle = '';
      switch (newMode) {
        case 'specific-date':
          eventTitle = 'Specific Date Selected';
          break;
        case 'date-range':
          eventTitle = 'Date Range Selected';
          break;
        case 'terminal':
          eventTitle = 'Terminal Selected';
          break;
        default:
          break;
      }

      track(eventTitle, {
        url: '/terminal-screenshots',
      });

      setSearchParams({ mode: newMode }, false);
    },
    [setSearchParams, track]
  );

  return (
    <FormControl component="fieldset">
      <RadioGroup
        row
        aria-label="mode-selection"
        defaultValue="terminal"
        name="radio-buttons-group"
        value={mode}
        onChange={onChange}
        className="flex flex-row items-center"
      >
        <h3 className="font-medium text-gray-900 pr-4">Search by:</h3>
        <FormControlLabel
          value="terminal"
          control={<Radio />}
          label={<h3 className="font-medium text-gray-700">Terminal (specific date)</h3>}
        />
        <FormControlLabel
          value="specific-date"
          control={<Radio />}
          label={<h3 className="font-medium text-gray-700">Shipping line (specific date)</h3>}
        />
        <FormControlLabel
          value="date-range"
          control={<Radio />}
          label={<h3 className="font-medium text-gray-700">Shipping line (date range)</h3>}
        />
      </RadioGroup>
    </FormControl>
  );
};
ModeSelector.displayName = 'ModeSelector';
